import React from 'react';
import { RaceTime, Duration } from '../types/Team';

interface RaceTimesGridProps {
  raceTime: RaceTime;
  netRaceTime: Duration;
  totalPauseTime: Duration;
}

export const RaceTimesGrid = ({ raceTime, netRaceTime, totalPauseTime }: RaceTimesGridProps) => {
  const formatTime = (dateString: string) => {
    return new Date(dateString).toLocaleTimeString();
  };

  const formatDuration = (duration: Duration) => {
    return `${duration.hours}h ${duration.minutes}m ${duration.seconds}s`;
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="text-sm text-gray-500 mb-1">Start Time</div>
        <div className="text-lg font-semibold text-gray-800">
          {formatTime(raceTime.startTime)}
        </div>
      </div>
      
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="text-sm text-gray-500 mb-1">Finish Time</div>
        <div className="text-lg font-semibold text-gray-800">
          {raceTime.finishTime ? formatTime(raceTime.finishTime) : 'Not finished'}
        </div>
      </div>
      
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="text-sm text-gray-500 mb-1">Net Race Time</div>
        <div className="text-lg font-semibold text-gray-800">
          {formatDuration(netRaceTime)}
        </div>
      </div>
      
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="text-sm text-gray-500 mb-1">Total Pause Time</div>
        <div className="text-lg font-semibold text-gray-800">
          {formatDuration(totalPauseTime)}
        </div>
      </div>
    </div>
  );
}; 